module.exports = __webpack_public_path__ + "img/image1.9d939024.jpg";